// Common
export const apiGetSystemKey = '/api/Common/GetSystemKey'
